export { IsMobileDevice } from "./functions/is-mobile-device/isMobileDevice.js";
export { TacticId } from "./functions/tacticId/getTacticId.js";
export { InitialMarketoKnownUserStatus } from "./functions/getInitialMarketoKnownUserStatus.js";